import React from 'react';
import IconCard, { IconCardProps } from 'molecules/IconCard/IconCard';
import Stack from 'atoms/Layout/Stack/Stack';
import IconCardGridContainer from './IconCardGrid.styles';

interface IconCardGridProps {
  itemsList: IconCardProps[];
}

const IconCardGrid = ({ itemsList }: IconCardGridProps): JSX.Element => {
  return (
    <IconCardGridContainer
      gap='spacing-4xl'
      gapMd='spacing-5xl'
      totalColumns={3}
      totalColumnsLg={2}
      totalColumnsMd={1}
    >
      {itemsList.map((item, index) => (
        <Stack
          key={index}
          justify='center'
          align='flex-start'
        >
          <IconCard {...item} />
        </Stack>
      ))}
    </IconCardGridContainer>
  );
};

export default IconCardGrid;
